import React, { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { RouteConfig } from 'utils/helper'

import { useNavigation } from '../../Context'

const CustomLink: React.FC<RouteConfig> = ({
  name,
  path,
  icon: Icon,
  submenu,
}) => {
  const { state } = useNavigation()
  const { t } = useTranslation()
  const location = useLocation()
  const [collapsed, setCollapsed] = useState({
    currentPath: '',
    isCollapsed: false,
  })

  const matchCurrentPath = (pathLink: string): boolean =>
    location.pathname.includes(pathLink)

  return (
    <div>
      <Link
        onClick={() => {
          if (submenu)
            setCollapsed({
              ...collapsed,
              currentPath: path,
              isCollapsed: matchCurrentPath(collapsed.currentPath)
                ? !collapsed.isCollapsed
                : true,
            })
        }}
        key={name}
        to={path}
        className={`block capitalize px-8 ${
          location.pathname === path && 'bg-flamingo-100'
        } ${
          matchCurrentPath(path) && 'text-flamingo'
        } py-5 hover:bg-flamingo-100 hover:text-flamingo transition ease-in-out duration-200`}
      >
        <>
          <Icon
            className={`inline mr-4 stroke-current stroke-0.6 hover:stroke-current hover:text-flamingo ${
              matchCurrentPath(path) && 'stroke-current text-flamingo'
            }`}
            height={20}
          />
          {!state.collapsed && t(name)}
        </>
      </Link>
      {!state.collapsed &&
        !!submenu &&
        matchCurrentPath(path) &&
        collapsed.isCollapsed &&
        submenu.map((submenuProps) => {
          return (
            <Link
              key={submenuProps.name}
              to={`${path}${submenuProps.path}`}
              className={`block capitalize ${
                matchCurrentPath(submenuProps.path) &&
                'bg-flamingo-100 text-flamingo'
              } py-5 pl-16 hover:bg-flamingo-100 hover:text-flamingo transition ease-in-out duration-200 ${
                state.collapsed ? 'px-4' : 'px-8'
              }`}
            >
              {t(submenuProps.name)}
            </Link>
          )
        })}
    </div>
  )
}

const Navigation: React.FC = () => {
  const { state } = useNavigation()

  return (
    <nav className={`flex flex-col ${state.collapsed && 'text-center'}`}>
      {state.routes.map((routeProps) => (
        <CustomLink key={routeProps.name} {...routeProps} />
      ))}
    </nav>
  )
}

export default Navigation
